import type { Pair } from '../messages';

/** A public profile: its stats row, the follower tabs and the not-found screen. */
export const profile = {
  'profile.since': ['на сайте с', 'with us since'],
  'profile.notFoundTitle': ['Профиль не найден', 'Profile not found'],
  'profile.notFoundBody': [
    (v) => `Аккаунта @${v.username} не существует — возможно, имя изменили.`,
    (v) => `@${v.username} does not exist — the name may have changed.`,
  ],
  'profile.tabLabel': ['Раздел профиля', 'Profile section'],
  'profile.tabFollowers': [(v) => `Подписчики · ${v.n}`, (v) => `Followers · ${v.n}`],
  'profile.tabFollowing': [(v) => `Подписки · ${v.n}`, (v) => `Following · ${v.n}`],
  'profile.statCollections': [
    'подборок открыто',
    (v) => (+v.n === 1 ? 'public collection' : 'public collections'),
  ],
  'profile.statFollowers': ['подписчиков', (v) => (+v.n === 1 ? 'follower' : 'followers')],
  'profile.statFollowing': ['подписок', 'following'],
  'profile.statLibrary': ['ссылок в библиотеке', (v) => (+v.n === 1 ? 'link in library' : 'links in library')],
  'profile.libraryPrivacy': [
    'Библиотека видна только вам. Наружу выходят подборки, которым вы сами задали видимость.',
    'Your library is visible only to you. Collections go public when you set their visibility.',
  ],
  'profile.nowThere': [(v) => ` Сейчас там ${v.words}.`, (v) => ` Currently ${v.words}.`],
  'profile.noFollowersTitle': ['Подписчиков пока нет', 'No followers yet'],
  'profile.noFollowingTitle': ['Пока ни на кого нет подписки', 'You follow nobody yet'],
  'profile.noFollowersBody': [
    'Подборки для подписчиков станут доступны, как только кто-то подпишется.',
    'Followers-only collections unlock as soon as someone follows you.',
  ],
  'profile.noFollowingBody': [
    'Найдите авторов в поиске — их подборки появятся в вашей ленте.',
    'Find authors in search — their collections show up in your feed.',
  ],
  'profile.noPublicMine': ['Публичных подборок ещё нет', 'No public collections yet'],
  'profile.noPublicTheirs': ['Открытых подборок пока нет', 'No open collections yet'],
  'profile.noPublicMineBody': [
    'Соберите маршрут из сохранённых ссылок и сделайте его публичным — он появится здесь и в ленте подписчиков.',
    'Build a route from saved links and make it public — it appears here and in your followers’ feed.',
  ],
  'profile.noPublicTheirsBody': [
    'Автор держит всё в привате. Загляните позже.',
    'This author keeps everything private. Come back later.',
  ],
} satisfies Record<string, Pair>;
